import React from 'react';
import * as ST from './styled';

interface ISlide {
    href: string,
    src: string,
    alt: string,
    cost: string,
}

interface IProps {
    slide: ISlide,
    slideWidth: number,
    slideMargin: number,
}

export const CarouselSlide = ({ slide, slideWidth, slideMargin } : IProps) => {
    return (
        <ST.SlideWrap
            slideWidth={slideWidth}
            slideMargin={slideMargin}
        >
            <ST.Image
                src={slide.src}
                alt={slide.alt}
                width='178'
                height='266'
            />
            <ST.SlideLink href={slide.href}>
                <ST.SlideDesc>
                    <ST.SlideTitle>{slide.alt}</ST.SlideTitle>
                    <ST.SlideCost>{slide.cost}</ST.SlideCost>
                </ST.SlideDesc>
            </ST.SlideLink>
        </ST.SlideWrap>
    );
};
